import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@alchemer/ui/components/alert-dialog';
import { formatTimeMMSS } from '@/utils/formatters';

interface IdleWarningDialogProps {
  open: boolean;
  remainingSeconds: number;
  onStayActive: () => void;
  onLogout: () => void;
}

export default function IdleWarningDialog({ open, remainingSeconds, onStayActive, onLogout }: IdleWarningDialogProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Session Expiring</AlertDialogTitle>
          <AlertDialogDescription>
            You will be logged out in <strong>{formatTimeMMSS(remainingSeconds)}</strong> due to inactivity.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onLogout}>Log Out</AlertDialogCancel>
          <AlertDialogAction onClick={onStayActive}>Stay Logged In</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
